export default __webpack_public_path__ + "static/media/placeholder_dummy2016-illustrator01-mobile-de.7ac990a4.png";